import React, { useContext } from 'react'
import NoIndex from '#src/components/NoIndex'
import { withUserAgent, WithUserAgentProps } from '#src/containers/UserAgent'
import { ResponseConsumer } from '#src/context/response'
import { Grid, GridItem, Button } from '@deal/components'
import LinkIcon from './link.svg'
import styles from './styles.css'
import { MaskedUserHandleFragment } from '#src/fragments/MaksedUserHandle.generated'
import { IdentityContext } from '#src/containers/Identity'
import { ContactType } from '#src/generated/types'
import { Link } from 'react-router-dom'

interface EntityNotAllowedProps {
  entityName: string
  maskedUserHandlers: MaskedUserHandleFragment[]
}

const EntityNotAllowed: React.FC<EntityNotAllowedProps & WithUserAgentProps> = ({
  children,
  entityName,
  maskedUserHandlers,
  userAgent
}) => {
  const { myself } = useContext(IdentityContext)
  const contacts = myself?.user.contacts.filter(
    contact => contact.type === ContactType.EMAIL || contact.type === ContactType.PHONE
  )

  // const loginUrl = encodeURIComponent(
  //   `/auth/login?${maskedUserHandlers.length > 0 ? `hid=${maskedUserHandlers[0].id}` : ''}`
  // )
  return (
    <ResponseConsumer>
      {context => {
        /**
         * Restrict mutation of status codes to bot traffic only, we can't modify
         * the headers for our regular (non-bot) SSR since we stream the response.
         */
        if (context && userAgent?.isBot) {
          context.handleSetStatusCode(404)
        }

        return (
          <>
            <NoIndex />
            <Grid>
              <GridItem col={2}>
                <div className={styles.wrapper}>
                  <div className={styles.copy}>
                    <div className={styles.header}>
                      You are not allowed to view this {entityName}
                    </div>
                    <div className={styles.body}>
                      {maskedUserHandlers.length > 0 ? (
                        <>
                          {contacts && contacts.length > 0 && (
                            <div>
                              You are currently logged in to the account associated with{' '}
                              {contacts.map(contact => contact.value).join(' and ')}
                            </div>
                          )}
                          <div>
                            This {entityName} belongs to account for{' '}
                            {maskedUserHandlers.map(handler => handler.maskedHandle).join(' and ')}
                          </div>
                          <div>
                            If you are the owner of that account, please log out and then log in
                            with the correct credential
                          </div>
                          <div className={styles.loginButton}>
                            <Link to={`/auth/logout}`} rel="nofollow">
                              <Button variant="contrast-outline">Log out</Button>
                            </Link>
                          </div>
                        </>
                      ) : (
                        <div>
                          You don't have permission to view this {entityName}. It belongs to a
                          different user account.
                          <div className={styles.homeButton}>
                            <Link to="/">
                              <Button variant="contrast-outline">Take me home</Button>
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={styles.icon}>
                    <LinkIcon className={styles.linkIcon} />
                  </div>
                </div>
              </GridItem>
            </Grid>
            {children}
          </>
        )
      }}
    </ResponseConsumer>
  )
}

export default withUserAgent(EntityNotAllowed)
